import _ from "lodash";
import React from "react";
import gdaClient from "../../../utils/gda/gdaClient";
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import EAButton from "../../EAButton";
import PropTypes from "prop-types";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {BEAUFTRAGTER, BETREIBER} from "../../../consts/funktionaleRollen";

export function LageVerortung({preName, data, formFactory, disabled, isButtonVisible, onClick, modus}) {
    const rechtswert = preName ? preName + "lage.rechtswert" : "lage.rechtswert";
    const hochwert = preName ? preName + "lage.hochwert" : "lage.hochwert";
    const confirm = useConfirmation();

    const getParsedRechtsAndHochwert = (f_data) => {
        // Falls ein Rechts- bzw. Hochwert als leerer String ("") übergeben wird,
        // zoomt GDA an eine Stelle. Daher muss explizit null übergeben werden.
        // Außerdem werden die Koordinaten teilweise als String zurückgegeben,
        // daher ist ein Parsing erforderlich
        return {
            rechtswert: f_data.lage?.rechtswert ? parseInt(f_data.lage.rechtswert) : null,
            hochwert: f_data.lage?.hochwert ? parseInt(f_data.lage.hochwert) : null,
        }
    };


    return (
        <div className="gridl" style={{gridTemplateColumns: "150px 150px 150px", padding: "var(--vertical-spacing) 0"}}>
            {formFactory.renderNumberInputNoThousandSeparator(rechtswert, rechtswert, "UTM32-Ost", disabled)}
            {formFactory.renderNumberInputNoThousandSeparator(hochwert, hochwert, "UTM32-Nord", disabled)}
            {<EAButton id="lageverortung"
                          label={formFactory.getReadonly() ? "Auf Karte betrachten" : "Lageverortung"}
                          onClick={() => {
                              window.tmpData = _.cloneDeep(data);
                              const parsedRechtsAndHochwert = getParsedRechtsAndHochwert(data);
                              gdaClient(null, {
                                  confirm: confirm,
                                  recieveCoordinate: (rechtsWertTmp, hochWertTmp) => {
                                      if (!formFactory.getReadonly()) {
                                          onClick({rechtswert: parseFloat(rechtsWertTmp), hochwert: parseFloat(hochWertTmp)});
                                      }
                                  },
                              }, modus).editCoordinate(parsedRechtsAndHochwert.rechtswert, parsedRechtsAndHochwert.hochwert);
                          }}
                />}
        </div>
    );
}

LageVerortung.propTypes = {
    formFactory: PropTypes.any.isRequired,
    data: PropTypes.any.isRequired,
    disabled: PropTypes.any.isRequired,
    isButtonVisible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
